export const PACKAGE_TYPES = {
  REGULAR: "offline_package",
  TRIAL: "trial_package",
  PLATINUM: "platinum_partner"
};

export const PACKAGE_LABELS = {
  offline_package: "Regular",
  trial_package: "Trial",
  platinum_partner: "Platinum"
};